<div class="side-heading"><span class="text-heading">Favorite</span></div>
<div class="side-collections" *ngIf="favCollections">
  <a class="card" *ngFor="let collection of favCollections;" [routerLink]="['collection', collection.id]"><div class="card-content">{{collection.name}}</div></a>
</div>
